import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { KAL_DIALOG_DATA, KalDate, KalDialogRef } from '@kalidea/kaligraphi';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { extractHourAndMinuteFromKalDate, getKalDateFromObject } from 'src/app/utils/date.utils';
import { FormValidator } from 'src/app/validators/form-validator';

export class SharedDateTimeRangeSelectionDialogData {
    accepted?: boolean;
    dateStart?: KalDate;
    dateEnd?: KalDate;
    dateStartLabel: string;
    dateEndLabel: string;
    shouldHideTime?: boolean;
}

@Component({
    selector: 'shared-date-time-range-selection-dialog',
    templateUrl: './shared-date-time-range-selection-dialog.component.html',
    styleUrls: ['./shared-date-time-range-selection-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedDateTimeRangeSelectionDialogComponent extends BaseComponent implements OnInit {

    form: UntypedFormGroup;

    constructor(protected readonly cdr: ChangeDetectorRef,
                private readonly fb: UntypedFormBuilder,
                @Inject(KAL_DIALOG_DATA) public readonly data: SharedDateTimeRangeSelectionDialogData,
                private readonly dialogRef: KalDialogRef<SharedDateTimeRangeSelectionDialogComponent>) {
        super(cdr);
    }

    submit(): void {
        const {
            dateStart,
            timeStart,
            dateEnd,
            timeEnd
        } = this.form.value;

        this.dialogRef.close({
            accepted: true,
            dateStart: this.parseDateTime(dateStart, timeStart),
            dateEnd: this.parseDateTime(dateEnd, timeEnd)
        });
    }

    close(): void {
        this.dialogRef.close({accepted: false});
    }

    private parseDateTime(dateAsString: string, time: string): KalDate {
        return new KalDate(dateAsString).set('hours', +time.substring(0, 2)).set('minutes', +time.substring(3, 5));
    }



    ngOnInit(): void {
        const startDate = this.data.dateStart || null;
        const endDate = this.data.dateEnd || null;

        const timeStart = !!startDate ? extractHourAndMinuteFromKalDate(getKalDateFromObject(this.data, 'dateStart')) : null;
        const timeEnd = !!endDate ? extractHourAndMinuteFromKalDate(getKalDateFromObject(this.data, 'dateEnd')) : null;

        this.form = this.fb.group({
            dateStart: [startDate, [FormValidator.isNotNull, FormValidator.date]],
            timeStart: [timeStart, [FormValidator.isNotNull]],
            dateEnd: [endDate, [FormValidator.isNotNull, FormValidator.date]],
            timeEnd: [timeEnd, [FormValidator.isNotNull]]
        }, {
            validators: [
                FormValidator.dateTimeRangeValidator('dateStart', 'dateEnd', 'timeStart', 'timeEnd'),
            ]
        });
    }

}
